import * as C from "react";
import { forwardRef as r } from "react";
const n = r(function(e, o) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.6167 4.58333C19.55 4.50002 19.4667 4.43332 19.3834 4.35001C18.3834 3.46665 16.9334 3 15.2833 3C15.15 3 14.9834 3 14.8334 3.01662C12.1834 3.15001 9.55004 4.43332 7.58337 6.53331C5.3 8.96662 4 11.9333 4 14.6667C4 16.2666 4.46671 17.6499 5.31669 18.5333C6.26668 19.55 7.66669 20.0666 9.33334 20.0666C10.3333 20.0666 11.4 19.8833 12.4667 19.4833C14.1833 18.8999 15.8167 17.8499 17.2334 16.4666C19.6 14.1499 21 11.15 21 8.41665C21 7.9 20.95 7.38329 20.85 6.89995C20.6334 5.98334 20.2167 5.19999 19.6167 4.58333ZM16.7 15.9C14.7834 17.7666 12.4167 18.9999 10.1834 19.25C8.93338 19.1666 8.66668 18.8833 8.61668 18.8166C8.65005 18.6833 8.88338 18.3167 10.1667 17.2666L10.4667 17C11.4834 16.1833 13.8667 14.25 15.5833 12.7L15.9667 12.35C17.0167 11.4333 18.7167 9.91667 20.2 7.91663C20.2167 8.08332 20.2333 8.24996 20.2333 8.41665C20.2333 10.95 18.9 13.75 16.7 15.9ZM7.28336 15.7667C7.01672 15.8667 6.73339 15.9667 6.53338 15.9667C6.15005 15.9667 5.75003 15.6667 5.68334 13.3333C5.60002 10.1166 7.96671 7.06665 10.0334 5.46662C11.65 4.38332 13.5334 3.78329 15.2833 3.78329C16.8667 3.78329 18.2167 4.26663 19.05 5.1333L19.1167 5.16667C19 8.19995 15.9667 10.4999 14.15 11.9L14.1167 11.9166C11.35 14.0166 8.38335 15.3833 7.61669 15.6333C7.50006 15.6833 7.40005 15.7167 7.28336 15.7667Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as RugbyLeague
};
